module.exports = __webpack_public_path__ + "prod/1.42.2/img/suse.a0364a82.png";